import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Share2 } from 'lucide-react';
import { Helmet } from 'react-helmet-async';
import { RelatedBlogPosts } from '../../../../components/Blog/RelatedBlogPosts';
import GoogleTranslateWidget from '../../../../components/GoogleTranslateWidget';
export function BlogPostNarcissismGaslightingPT() {
  const articleData = {
    title: 'Aprenda Sobre o Termo: Narcisismo e Gaslighting',
    description: 'Confuso com comportamentos narcisistas ou gaslighting? Aprenda os principais sinais em textos e veja como a IA do Toxic Detector identifica instantaneamente padrões de manipulação sutis.',
    slug: 'narcissism-gaslighting-explained',
    publishDate: '2025-07-15',
    author: 'Toxic Detector Editorial'
  };
  const handleShare = async () => {
    try {
      await navigator.share({
        title: articleData.title,
        text: articleData.description,
        url: window.location.href
      });
    } catch (err) {
      navigator.clipboard.writeText(window.location.href);
      alert('Link copiado para a área de transferência!');
    }
  };
  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    headline: articleData.title,
    description: articleData.description,
    image: 'https://toxicdetector.com/pt/blog/narcissism-gaslighting-explained.jpg',
    author: {
      '@type': 'Person',
      name: articleData.author
    },
    publisher: {
      '@type': 'Organization',
      name: 'ToxicDetector',
      logo: {
        '@type': 'ImageObject',
        url: 'https://toxicdetector.com/logo.png'
      }
    },
    datePublished: articleData.publishDate,
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `https://toxicdetector.com/pt/blog/${articleData.slug}`
    }
  };
  return <div className="min-h-screen bg-gray-50" data-id="element-8732" data-mp="2r0e8hh2ovlv9">
      <GoogleTranslateWidget data-id="element-8733" data-mp="2r3s7cfc59cxy" />
      <Helmet data-id="element-8734" data-mp="2vzzeuck6uwi0">
        <title data-id="element-8735" data-mp="2vzhdx2mkzu3r">Narcisismo e Gaslighting Explicados | ToxicDetector</title>
        <meta name="description" content="Entenda a psicologia por trás das estratégias de manipulação de narcisismo e gaslighting." data-id="element-8736" data-mp="vxzpdwzj48xd" />
        <meta property="og:image" content="https://cdn.magicpatterns.com/uploads/iLMUMmEFFWiRSqv8DSTAdz/file_00000000f0c8720a9c4e7f9e2fbdea6d.png" data-id="element-8737" data-mp="ryqu2nouc2zp" />
        <meta name="keywords" content="narcisismo, gaslighting, manipulação, psicologia, análise de IA" data-id="element-8738" data-mp="10xvr1pkr7o9r" />
        <link rel="canonical" href={`https://toxicdetector.com/pt/blog/${articleData.slug}`} data-id="element-8739" data-mp="d5f5v65pzg68" />
        <script type="application/ld+json" data-id="element-8740" data-mp="my33u48frq6j">
          {JSON.stringify(articleSchema)}
        </script>
      </Helmet>

      <header className="bg-white/90 border-b border-gray-200 sticky top-0 z-50 backdrop-blur-sm" data-id="element-8741" data-mp="i6l57mtvy1oq">
        <div className="max-w-3xl mx-auto px-6 py-4" data-id="element-8742" data-mp="3qlmmmgveuxar">
          <div className="flex items-center justify-between" data-id="element-8743" data-mp="3qkbk0kdpbvl8">
            <Link to="/" className="text-2xl font-bold tracking-tight text-gray-900" data-id="element-8744" data-mp="3ln1xpdlm001m">
              🚩 ToxicDetector
            </Link>
            <button onClick={handleShare} className="p-2.5 hover:bg-gray-50 rounded-lg transition-colors" aria-label="Share article" data-id="element-8745" data-mp="25wiyvdsofjhm">
              <Share2 size={20} className="text-gray-600" data-id="element-8746" data-mp="1w5xwrgdsnwty" />
            </button>
          </div>
        </div>
      </header>

      <article className="max-w-3xl mx-auto w-full px-6 py-12" data-id="element-8747" data-mp="2jxbtdyizaekq">
        <Link to="/blog" className="inline-flex items-center text-gray-600 text-sm mb-10 hover:text-gray-900 transition-colors group" data-id="element-8748" data-mp="2ouv9l3z8l1fb">
          <ArrowLeft size={16} className="mr-2 group-hover:-translate-x-1 transition-transform" data-id="element-8749" data-mp="2axgb79r09jb7" />
          Voltar ao Blog
        </Link>

        <header className="mb-12" data-id="element-8750" data-mp="zfdss8f5t62b">
          <h1 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight leading-tight text-gray-900" data-id="element-8751" data-mp="zijjtt7cmi0o">
            {articleData.title}
          </h1>
          <div className="flex items-center text-gray-600 text-sm gap-3" data-id="element-8752" data-mp="1jpyhr1ntq142">
            <time dateTime={articleData.publishDate} data-id="element-8753" data-mp="1exolz50126tv">
              {new Date(articleData.publishDate).toLocaleDateString('pt-BR', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
            </time>
            <span className="text-gray-300" data-id="element-8754" data-mp="15vp46ah6uypv">•</span>
            <span data-id="element-8755" data-mp="22mq1tdb6wk96">{articleData.author}</span>
          </div>
        </header>

        <div className="prose prose-lg max-w-none" data-id="element-8756" data-mp="1xo6eb8gy70ep">
          <p className="text-xl mb-8 leading-relaxed text-gray-700" data-id="element-8757" data-mp="1xphdsw3d1m00">
            Já se perguntou por que algumas pessoas fazem você se sentir
            confuso, cansado ou duvidando de si mesmo em relacionamentos? Isso
            geralmente é <strong data-id="element-8758" data-mp="i7o31mmcakkh">narcisismo e gaslighting</strong> em ação.
          </p>

          <section className="mb-12" data-id="element-8759" data-mp="i5l1q6fql50g">
            <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-8760" data-mp="d8l7qtw5vspp">
              O que é Narcisismo?
            </h2>
            <p className="text-lg leading-relaxed text-gray-600 mb-6" data-id="element-8761" data-mp="2oxrfmnhyccl6">
              <strong data-id="element-8762" data-mp="2tuhvpatrb86l">Narcisismo</strong> é um padrão de comportamento
              egocêntrico e manipulador onde alguém prioriza suas próprias
              necessidades sobre as dos outros.
            </p>
          </section>

          <section className="mb-12" data-id="element-8763" data-mp="32p5woosau3pl">
            <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-8764" data-mp="37mo8cmxpax1a">
              O que é Gaslighting?
            </h2>
            <p className="text-lg leading-relaxed text-gray-600 mb-6" data-id="element-8765" data-mp="3ckpr16r7suc8">
              <strong data-id="element-8766" data-mp="3hl54dybhy1u7">Gaslighting</strong> é uma técnica de manipulação
              psicológica que faz você questionar sua própria realidade, memória
              ou sentimentos.
            </p>
          </section>

          <section className="mb-12" data-id="element-8767" data-mp="1n7mb50oi15ep">
            <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-8768" data-mp="1n8nmz7dc9vxh">
              Como Nossa IA Detecta Esses Padrões
            </h2>
            <p className="text-lg leading-relaxed text-gray-600 mb-6" data-id="element-8769" data-mp="2uitqu82ghpn7">
              Em vez de adivinhar, nossa IA analisa suas conversas em busca de
              padrões de manipulação.
            </p>
          </section>

          <section className="mb-12" data-id="element-8770" data-mp="33l2ymq6cb4ww">
            <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-8771" data-mp="33hxbvhl6of4c">
              Por Que Entender Isso Importa
            </h2>
            <p className="text-lg leading-relaxed text-gray-600" data-id="element-8772" data-mp="3dhftvshj9qtr">
              Reconhecer <strong data-id="element-8773" data-mp="38jeb78o0rtit">narcisismo</strong> ou{' '}
              <strong data-id="element-8774" data-mp="38ild0w34mcca">gaslighting</strong> cedo protege sua saúde emocional.
            </p>
          </section>
        </div>

        <div className="bg-purple-600 rounded-2xl p-10 text-center text-white mt-16" data-id="element-8775" data-mp="3na3n6d9b1cnq">
          <h2 className="text-3xl font-bold mb-4 tracking-tight" data-id="element-8776" data-mp="3i9pqfrd5lp50">
            💀 Pronto Para Ver a Verdade?
          </h2>
          <p className="text-purple-100 mb-8 text-lg leading-relaxed max-w-2xl mx-auto" data-id="element-8777" data-mp="ylkpr5fuhf">
            Pare de adivinhar. Envie seus textos para o Toxic Detector e obtenha
            uma pontuação de toxicidade instantânea.
          </p>
          <Link to="/signup" className="inline-block bg-white text-purple-600 px-10 py-4 rounded-lg font-bold text-lg hover:bg-gray-50 transition-colors" data-id="element-8778" data-mp="jpd0ejfnp7hp">
            Escaneie Seus Chats Agora →
          </Link>
        </div>

        <div className="mt-16" data-id="element-8779" data-mp="9srtttnznobr">
          <RelatedBlogPosts posts={[{
          title: '7 Sinais de Gaslighting',
          description: 'Aprenda os principais padrões de gaslighting que a IA detecta em suas conversas de texto.',
          slug: '7-signs-of-gaslighting',
          emoji: '💀'
        }, {
          title: 'Seu Ex é um Narcisista Oculto?',
          description: 'Descubra se seu ex mostra sinais de comportamento narcisista oculto através da análise de texto.',
          slug: 'is-your-ex-a-covert-narcissist',
          emoji: '🎭'
        }]} data-id="element-8780" data-mp="3s4mvv8p1jegi" />
        </div>
      </article>

      <footer className="bg-white border-t border-gray-200 py-12 mt-16" data-id="element-8781" data-mp="3opd6ffxqmcvw">
        <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-8782" data-mp="3jo7e3j7zormw">
          <p className="text-gray-500 text-sm" data-id="element-8783" data-mp="3jqtnloefxh7r">
            © {new Date().getFullYear()} ToxicDetector. Todos os direitos
            reservados.
          </p>
        </div>
      </footer>
    </div>;
}